import { render, staticRenderFns } from "./Sv2I18n.vue?vue&type=template&id=478b896c&scoped=true&"
import script from "./Sv2I18n.vue?vue&type=script&lang=js&"
export * from "./Sv2I18n.vue?vue&type=script&lang=js&"
import style0 from "./Sv2I18n.vue?vue&type=style&index=0&id=478b896c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b896c",
  null
  
)

export default component.exports